module.exports = __webpack_public_path__ + "img/posologie-hamid-synthese-1.626bc697.png";